import { useSelector } from "react-redux";
import DefaultFaqsBase from "./DefaultFAQ";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setDefaultContent } from "src/reducers/slices/SetDefaultDataSlice";
import content from "../../../../StaticContent.json";

const DefaultFaqPage = () => {
  const dispatch = useDispatch();
  const defaultData = useSelector((state: any) => state.getDefaultData.value);

  useEffect(() => {
    const getData = async () => {
      try {
        const result: any = content;

        if (result) {
          dispatch(setDefaultContent(result.content));
        }
      } catch (err) {
        console.log('getData', err);
      }
    };
    getData();
  }, []);

  const faqData =
    defaultData != null ? defaultData?.DefaultDataDetails?.faq : "";

  return (
      <>
      <DefaultFaqsBase accordionInfo={faqData} />
      </>
  );
};
export default DefaultFaqPage;
